import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import Toast from "cogo-toast";
import {DefaultLoader} from "../../../components/DefaultLoader";
import {FiPlus} from "react-icons/fi";
import AccessUserTable from "./AccessUserTable";
import {apiGetUser} from "./Actions";
import {TurnstileButton} from "../components/Button";
import PageHeader from "../components/PageHeader";
import {EmptyState} from "../components/Table";

const AccessUser = () => {
    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);
    let user = useSelector((state) => state.user);

    useEffect(() => {
        user.activeAreal && getData();
    }, [user.activeAreal]);

    const getData = () => {
        setLoading(true);
        apiGetUser(user.activeAreal.id, null, (data) => {
            setData(data);
            setLoading(false);
        }, (error) => {
            Toast.error("Při načítání uživatelů nastala chyba.");
            setLoading(false);
        });
    };

    const _renderBody = () => {
        if (loading) return <DefaultLoader text={"Načítám uživatele..."}/>;
        if (!loading && data) return <AccessUserTable data={data} setData={setData}/>;
        else return <EmptyState/>;
    };

    return (
        <div>
            {user.activeAreal && (
                <div>
                    <PageHeader crumbs={[{label: "Interní uživatelé"}]}>
                        {user?.user?.rights?.enigooTurniketsEdit && (
                            <TurnstileButton link="/access/user/add" text="PŘIDAT" icon={<FiPlus size={12}/>}/>
                        )}
                    </PageHeader>
                    {_renderBody()}
                </div>
            )}
        </div>
    );
};

export default AccessUser;
